import LogscaleSvgIcon from './LogscaleSvgIcon';

export default LogscaleSvgIcon;
